import { z } from 'zod'
import { RewardSchema } from '@/model/rewardDto'
import { ExtendedOrganisationSchema } from '@/model/organisationDto'

const PROVIDER = ['GOOGLE', 'CUSTOM', ''] as const
export const ROLES = [
  'ROLE_USER',
  'ROLE_ADMIN',
  'ROLE_ORGANISATION_ADMIN',
  'ROLE_RSS_FETCHER',
  'ROLE_UNFINISHED',
  'ROLE_SALES',
  'ROLE_BETA_TESTER',
  'ROLE_CHIEF_EDITOR',
  'ROLE_TIER_1',
  'ROLE_TIER_2',
  'ROLE_TIER_3',
  'ROLE_TIER_4',
  'ROLE_PILOT_USER',
  'ROLE_MUST_CHANGE_PASSWORD'
] as const

export const MeSchema = z.object({
  bookmarkedArticles: z.array(RewardSchema).default([]),
  deactivated: z.boolean().default(false),
  email: z.string().default(''),
  loginOption: z.enum(PROVIDER).default(PROVIDER[2]),
  name: z.string().default(''),
  organisation: ExtendedOrganisationSchema.default({}),
  promptRewards: z.array(RewardSchema).default([]),
  roles: z.array(z.enum(ROLES)).default([]),
  tokenUsage: z.number().default(0),
  userCustomization: z
    .object({
      leftLayout: z.array(z.string()).default([]),
      rightLayout: z.array(z.string()).default([])
    })
    .default({}),
  username: z.string().default(''),
  uuid: z.string().default('')
})

export type Me = z.infer<typeof MeSchema>
